import moment from 'moment'
import { certifications } from '@/config/certifications'

const groupArray = require('group-array')

export function isValidUUID (uuid) {
  if (Object.prototype.toString.call(uuid) !== '[object String]') {
    return false
  }

  uuid = uuid.toLowerCase()

  const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i

  return pattern.test(uuid)
}

export function snakeCaseToTitle (snakeCase) {
  return snakeCase.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
}

export function getCertificateLicenseTypeById (aircraftType) {
  const certificate = certifications.find(licenseType => licenseType.id === aircraftType)

  if (!certificate.name) {
    return aircraftType
  }

  return certificate.name
}

export function getCertificateTypeById (type, name) {
  const certificate = certifications.find(licenseType => licenseType.id === name)

  if (!certificate.licenses) {
    return type
  }

  const licence = certificate.licenses.find(item => item.value === type)

  if (!licence.name) {
    return type
  }

  return licence.name
}

export function parseEndpointError (error) {
  const values = Object.keys(error).map(key => `${snakeCaseToTitle(key)}: ${error[key]}`)
  return [].concat.apply([], values).join(', ')
}

export function groupCertificates (certificates) {
  if (!Array.isArray(certificates) || !certificates.length) {
    return {}
  }

  const groupedCertificates = groupArray(certificates, 'aircraft_type')

  const certs = new Map()
  Object.keys(groupedCertificates).forEach((key) => {
    if (!certs.get(key)) {
      certs.set(key, {
        name: getCertificateLicenseTypeById(key),
        items: []
      })
    }

    const items = groupedCertificates[key].map((item) => {
      item.name = getCertificateTypeById(item.type, item.aircraft_type)
      return item
    })

    certs.get(key).items.push(...items)
  })

  return [...certs.values()]
}

export function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function parseEngineType (string) {
  if (!string.length) {
    return ''
  }

  return string.split('_').map(capitalizeFirstLetter).join(' - ')
}

export function getAircraftData (airplane) {
  return {
    planeName: `${airplane?.type?.make} ${airplane?.type?.model}`,
    engineType: parseEngineType(airplane?.engine_type || ''),
    tag: airplane?.tail_number || '',
    img: airplane?.image || airplane?.type?.image || '',
    retractable: airplane?.retractable || false,
    id: airplane?.id || 0
  }
}

export function isMobileOrTablet (context) {
  return context.$windowWidth && window.matchMedia('(max-width: 1024px)').matches
}

export function isMobile (context) {
  return context.$windowWidth && window.matchMedia('(max-width: 768px)').matches
}

/* eslint-disable */
export function isMobileBrowser () {
  let check = false;
  (function(a,b){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

export function addOrdinal (n) {
  n = Number(n)
  if (isNaN(n)) {
    return n
  }
  return n + (['st', 'nd', 'rd'][((n + 90) % 100 - 10) % 10 - 1] || 'th')
}

export function pluralize (number, single) {
  return `${number} ${pluralizeWord(number, single)}`
}
export function pluralizeWord (number, single) {
  return `${single}${number === 1 ? '' : 's'}`
}

export function formatDate (unixTS) {
  if (!unixTS) { return '' }
  return moment(new Date(unixTS * 1000)).format('MMM DD, YYYY')
}

export function truncateText (text, size) {
  return text.length > size ? text.slice(0, size - 1) + '...' : text
}

export const buildFormData = (formData, data, parentKey) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}.${key}` : key)
    })
  } else if (data instanceof Blob) {
    const value = data == null ? '' : data
    formData.append(parentKey, value, 'file.png')
  } else {
    const value = data == null ? '' : data
    formData.append(parentKey, value)
  }
}

export const jsonToFormData = (data) => {
  const formData = new FormData()
  buildFormData(formData, data)

  return formData
}
export const validEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * @returns Parse notification data.
 * @param notification
 */
export function getNotification (notification) {
  return {
    id: notification?.id || 0,
    type: notification.type,
    person: {
      id: notification?.actor?.id || 0,
      username: notification?.actor?.username || notification?.actor?.id,
      name: notification?.actor?.first_name + ' ' + notification?.actor?.last_name,
      imageUrl: notification?.actor?.picture_url
    },
    message: notification.verb,
    unread: notification.unread,
    timestamp: notification.timestamp,
    fromNow: moment.unix(notification.timestamp).fromNow(),
    notification
  }
}
